import React, { Component } from 'react';
import { Redirect} from 'react-router-dom';
import { Input, Row, Modal, Select, Checkbox } from 'antd';
import Button from '../common/atoms/DSButton';

const Option = Select.Option;

class PreEmpFilters extends Component {

	constructor(props) {
    super(props)
    this.state = {
      appointment_status: this.props.filters.appointment_status,
      doctor_status: this.props.filters.doctor_status,
      reports_digitized: this.props.filters.reports_digitized,
      company_staff: this.props.filters.company_staff,
      filtered: this.props.selected_filters,  
      visible: true,
      error_msg: "",
      role: sessionStorage.getItem('role')
    }
  }

  handleOk = (e) => {
    this.props.updateFilters(this.state.filtered)
  }

  handleCancel = (e) => {
    this.setState({visible: false},function(){
      this.props.closeModal()
    })
  }

  apptStatusChange(status) {
    let data = this.state.filtered
    data.selected_appointment_status = status 
    this.setState({filtered: data})
  }

  companyStaffChange(staff) {
    let data = this.state.filtered
    data.selected_company_staff = staff 
    this.setState({filtered: data})
  }

  doctorStatusChange(doc_status) {
    let data = this.state.filtered
    data.selected_doctor_status = doc_status 
    this.setState({filtered: data})
  }

  onReportsDigitizedCheck = (e) => {
    let data = this.state.filtered
    data.selected_reports_digitized = e.target.checked 
    this.setState({filtered: data})
  }

  showUploadedFilter(){
    if (this.state.role !== 'regional_staff'){
      return(
        <Select
            mode="multiple"
            style={{ width: '100%', backgroundColor: '#fff'}}
            placeholder="Select HR"
            onChange={this.companyStaffChange.bind(this)}
            value={this.state.filtered.selected_company_staff}
        >
            {
              this.state.company_staff.map((key) => {
                return (<Option value={key.id}>{key.name}</Option>);
              })
            }
        </Select>
      )  
    }     
  }

  render(){
    if (this.state.visible && this.state.role === 'regional_staff'){
      return(
        <Modal
            title="Filters"
            visible={this.state.visible}
            onOk={this.handleOk.bind(this)}
            onCancel={this.handleCancel}
          >
            <h4>Appointment Status</h4>
            <Select
                mode="multiple"
                style={{ width: '100%', backgroundColor: '#fff'}}
                placeholder="Select appointment status"
                onChange={this.apptStatusChange.bind(this)}
                value={this.state.filtered.selected_appointment_status}
            >
                {
                  this.state.appointment_status.map((key) => {
                    return (<Option value={key}>{key} </Option>);
                  })
                }
            </Select>
            <br/>
            <br/>
            <h4>Doctor Status</h4>
            <Select
                mode="multiple"
                style={{ width: '100%', backgroundColor: '#fff'}}
                placeholder="Select doctor status"
                onChange={this.doctorStatusChange.bind(this)}
                value={this.state.filtered.selected_doctor_status}
            >
                {
                  this.state.doctor_status.map((key) => {
                    return (<Option value={key}>{key} </Option>);
                  })
                }
            </Select>
            <br/>
            <br/>
            <Checkbox onChange={this.onReportsDigitizedCheck} checked={this.state.filtered.selected_reports_digitized}>
              Reports Digitized
            </Checkbox>
            <br/>
            <br/>
            <p style={{color: "red"}}>{this.state.error_msg}</p>          
          </Modal>
      )
    }
    else {
      return(
        <Modal
            title="Filters"
            visible={this.state.visible}
            onOk={this.handleOk.bind(this)}
            onCancel={this.handleCancel}
          >
            <h4>Appointment Status</h4>
            <Select
                mode="multiple"
                style={{ width: '100%', backgroundColor: '#fff'}}
                placeholder="Select appointment status"
                onChange={this.apptStatusChange.bind(this)}
                value={this.state.filtered.selected_appointment_status}
            >
                {
                  this.state.appointment_status.map((key) => {
                    return (<Option value={key}>{key} </Option>);
                  })
                }
            </Select>
            <br/>
            <br/>
            <h4>Doctor Status</h4>
            <Select
                mode="multiple"
                style={{ width: '100%', backgroundColor: '#fff'}}
                placeholder="Select doctor status"
                onChange={this.doctorStatusChange.bind(this)}
                value={this.state.filtered.selected_doctor_status}
            >
                {
                  this.state.doctor_status.map((key) => {
                    return (<Option value={key}>{key} </Option>);
                  })
                }
            </Select>
            <br/>
            <br/>
            <h4>Uploaded By</h4>
              <Select
                mode="multiple"
                style={{ width: '100%', backgroundColor: '#fff'}}
                placeholder="Select HR"
                onChange={this.companyStaffChange.bind(this)}
                value={this.state.filtered.selected_company_staff}
              >
                {
                  this.state.company_staff.map((key) => {
                    return (<Option value={key.id}>{key.name}</Option>);
                  })
                }
              </Select> 
            <br/>
            <br/>
            <Checkbox onChange={this.onReportsDigitizedCheck} checked={this.state.filtered.selected_reports_digitized}>
              Reports Digitized
            </Checkbox>
            <br/>
            <br/>
            <p style={{color: "red"}}>{this.state.error_msg}</p>          
          </Modal>
      )
    }  
  }

}

export default PreEmpFilters;  